exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".sgr-homepage .mainLoading {\n  position: absolute;\n  width: 100%;\n  height: 100vh;\n  background: black;\n  z-index: 99999; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/organisms/MainLogin/MainLogin.scss
// module id = 1429
// module chunks = 0